class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector('a');
    removeFilterNode.addEventListener('click', (e) => {
      e.preventDefault();
      const filtersForm = this.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      
      // 获取新的 URL 参数
      const newSearchParams = new URL(removeFilterNode.href).searchParams.toString();
      
      // 更新页面数据
      filtersForm.renderPage(newSearchParams);

      // 刷新整个页面
      window.location.href = `${window.location.pathname}?${newSearchParams}`;
    });
  }
}

customElements.define('facet-remove', FacetRemove);
